// Shared helpers for talking to the AI service: resolve its base URL from the
// runtime env config and read the Okta bearer token the same way the existing
// RTK Query services do (see src/service-definitions/estimates.js).

// AI_SERVICE_URL is set per-environment and empty where the service isn't deployed,
// making its presence the deploy-time on switch for the feature.
export function isAiServiceConfigured(): boolean {
  return Boolean(window?._env_?.AI_SERVICE_URL);
}

export function getAiServiceBaseUrl(): string {
  const url = window?._env_?.AI_SERVICE_URL;
  if (typeof url !== 'string' || !url) {
    throw new Error('AI_SERVICE_URL is not configured in env-config.js');
  }
  // Normalize away a trailing slash so callers can append `/sessions`, `/chat`.
  return url.replace(/\/+$/, '');
}

// Read from storage on every request, exactly as the RTK Query services do in their
// prepareHeaders. Okta's tokenManager auto-renews in the background (autoRenew
// defaults to true, and OKTAConfig overrides nothing) and writes the fresh token
// back here, so re-reading per request is what picks renewals up -- a long-open
// drawer keeps working without any expiry handling of its own.
export function getOktaAccessToken(): string {
  const raw = localStorage.getItem('okta-token-storage');
  const token = raw ? JSON.parse(raw)?.accessToken?.accessToken : undefined;
  if (!token) {
    // Fail loudly like the existing services rather than sending an unauthenticated
    // request: a silent 401 from the AI service reads as "the service is broken"
    // instead of "you have no token". Surfaces in the drawer's error banner.
    throw new Error('No Okta access token available');
  }
  return token;
}

export function authHeaders(): Record<string, string> {
  return {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${getOktaAccessToken()}`,
  };
}
